import { render, staticRenderFns } from "./FinaliseStep.vue?vue&type=template&id=a3c3c020&"
import script from "./FinaliseStep.vue?vue&type=script&lang=ts&"
export * from "./FinaliseStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports